import { Card, Separator, Skeleton } from '@mokoboko/components';

import { ReceiptRowSkeleton } from './receipt-rows';

export const ClassReceiptSkeletonContent = () => {
  return (
    <>
      <div className="flex flex-col items-center">
        <Skeleton isCircle height={80} />
        <div className="mt-3">
          <Skeleton text="body-sm" width={80} />
        </div>
        <div className="mt-1.5">
          <Skeleton text="h2" width={192} />
        </div>
        <div className="mt-1">
          <Skeleton text="body-sm" width={112} />
        </div>
      </div>

      <Separator />

      <div className="flex flex-col gap-5">
        {Array.from({ length: 3 }).map((_, i) => (
          <ReceiptRowSkeleton key={i} />
        ))}
      </div>

      <Separator />

      <div className="flex flex-col gap-3">
        <Skeleton text="body" width={208} />
        <Skeleton isRounded height={44} width="100%" />
        <Skeleton isRounded height={44} width="100%" />
      </div>

      <Separator />

      <div className="flex flex-col gap-2">
        <Skeleton text="caption" width={96} />
        <div className="flex gap-4 max-[372px]:flex-col">
          <Skeleton isRounded height={44} width="100%" className="flex-1" />
          <Skeleton isRounded height={44} width="100%" className="flex-1" />
        </div>
      </div>

      <div className="flex w-full flex-col gap-2">
        <Skeleton text="caption" width={112} />
        <div className="flex w-full gap-4">
          <Skeleton isRounded height={44} width="100%" className="flex-1" />
          <Skeleton isRounded height={44} width="100%" className="flex-1" />
        </div>
      </div>
    </>
  );
};

export const ClassReceiptSkeleton = () => {
  return (
    <Card contentClassName="p-5 sm:p-6 flex flex-col gap-5 sm:gap-6">
      <div className="flex items-center justify-between gap-4">
        <Skeleton isRounded className="!h-11 w-[140px] sm:!h-10 sm:w-[124px]" />
      </div>

      <Separator />

      <ClassReceiptSkeletonContent />
    </Card>
  );
};
